import { useEffect, useReducer } from 'react';
import { API } from '../../api/api';
import { URLS } from '../../api/urls';
import { useAlert } from '../../context/Alert.context';
import { GadgetDto } from '../../types/gadgets.types';
import { ModelDto } from '../../types/models.types';
import { ITradeIn } from '../../types/tradeIn.types';
import { ModalKeys } from './chooseModal';
import { initialState, reducer } from './reducer/reducer';
import { actionGadgetTypes } from './reducer/reducer.type';

export const useGadgetsPage = () => {
  const [
    { gadgets, loading, selectedGadget, selectedModel, choosenModal },
    dispatch,
  ] = useReducer(reducer, initialState);
  const { showAlert } = useAlert();

  useEffect(() => {
    API.get<GadgetDto[]>(`${URLS.GADGETS}?models=true&tradeIn=true`)
      .then(({ data }) => {
        dispatch({ type: actionGadgetTypes.SET_GADGETS, payload: data });
      })
      .catch((e) => showAlert({ message: e.message, severity: 'error' }))
      .finally(() =>
        dispatch({ type: actionGadgetTypes.SET_LOADING, payload: false }),
      );
  }, []);

  const actions = {
    setModal: (value: ModalKeys | null) =>
      dispatch({ type: actionGadgetTypes.SET_CHOOSEN_MODAL, payload: value }),
    setSelectedGadget: (gadget: GadgetDto | null) =>
      dispatch({
        type: actionGadgetTypes.SET_SELECTED_GADGET,
        payload: gadget,
      }),
    setSelectedModel: (model: ModelDto | null) =>
      dispatch({ type: actionGadgetTypes.SET_SELECTED_MODEL, payload: model }),
    closeModal: () =>
      dispatch({ type: actionGadgetTypes.SET_CHOOSEN_MODAL, payload: null }),
  };

  const updateModelAfterEditTradeIn = (tradeIn: ITradeIn, model: ModelDto) => {
    const updatedGadgets: GadgetDto[] = gadgets.map((gadget: GadgetDto) => {
      if (gadget.id === model.gadgetId) {
        return {
          ...gadget,
          models: gadget?.models?.map((item) => {
            if (model.id === item.id) {
              return {
                ...item,
                tradeIn,
              };
            }
            return item;
          }),
        };
      }
      return gadget;
    });
    dispatch({ type: actionGadgetTypes.SET_GADGETS, payload: updatedGadgets });
  };

  return {
    gadgets,
    loading,
    selectedGadget,
    selectedModel,
    choosenModal,
    updateModelAfterEditTradeIn,
    ...actions,
  };
};
